import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';
import localforage from 'localforage';
import {
  checkButtonValidation,
  handleOnClickValidation
} from '../../utils/buttonsValidator';
import './styles.css';
import { rrulestr } from 'rrule';
import { useClickAway } from 'react-use';
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownButton,
  Form,
  OverlayTrigger,
  Spinner,
  Tooltip
} from 'react-bootstrap';
import { BUTTONS_CONFIG } from '../../config/buttonsValidatorsConfig';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  deleteAllOverlays,
  sendPostData,
  setModalUiContent,
  setShowPostIdeaModal,
  setShowProfileGroupSelectModal,
  updateMediaAssetFile
} from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import {
  getDateTimeFormated,
  getDateTimeFormattedMoment
} from '../../../utils/dates/utils';
import toast from 'react-hot-toast';
import {
  postHasPublicationDate,
  showButton
} from '../../config/buttonsValidatorsFunctions';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';
import {
  ACTIONS_THAT_REQUIRE_PERMISSION,
  BTN_APPROVAL_REQUEST_APPROVE,
  BTN_APPROVAL_REQUEST_REJECT,
  BTN_PLAN_PUBLICATION,
  BTN_PUBLISH_NOW,
  BTN_SAVE_AS_DRAFT,
  POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
  POST_STATUS_WAITING_FOR_APPROVAL,
  POST_SUB_STATUS_SAVED_AS_APPROVED_POST,
  STORY
} from '../../config/constants';
import { relocatePublishButtons } from '../../utils/uploadMediaFile';
import { setApprovalUI } from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import PostApprovalSection from './postApprovalSection';
import {
  blobToFile,
  blobToPNGFile,
  determineImageDimensionsFromURL,
  getImageDimensions,
  getImageDimensionsFromfile,
  getObjectAsFile,
  handleUploadMedia,
  sleepFor1000Ms,
  waitForUUIDs
} from '../../utils/helpers';
import { ALL, UPLOAD_TYPE_POST_MEDIA } from '../../../../config/constants';
import { store } from '../../../../redux/store';
import { TARGET_PUBLISH_WITH_SCHEDULE } from '../../../../redux/slices/LomavisPostApproval/constants';
import { setBulkImportUiAttribute } from '../../../../redux/slices/bulkPostsImport';
import UpgradeRequiredTooltipWrapper from '../../../utils/billing/UpgradeRequiredTooltipWrapper';
import moment from 'moment';
import {
  platformFeatures,
  POST_TYPE_KEY,
  POST_TYPE_REEL_KEY,
  POST_TYPE_STORY_KEY
} from '../../config/platformFeatures';
import { all } from 'axios';
import { LomavisOverlayToolTip1 } from '@/lomavisSharedUi/atoms/overlays/lomavisOverlayToolTip1/lomavisOverlayToolTip1';
import { PATH_PAGE } from '@/routes/paths';
import { useParams } from 'react-router-dom';
import { validateUpload } from '../../config/postValidator';
import LomavisMoreInfoIcon from '@/lomavisSharedUi/atoms/icons/LomavisMoreInfoIcon/LomavisMoreInfoIcon';
import { ConfirmationModal } from '../confirmationModal';

export const ButtonsBar: React.FC<any> = ({}) => {
  const submitButtonRef = useRef(null);
  const isUploadingButtonRef = useRef(null);
  const footerRef = useRef(null);
  const [rightMargin, setRightMargin] = useState(0);
  useEffect(() => {
    relocatePublishButtons({
      footerRef,
      setRightMargin
    });

    window.onresize = () => {
      relocatePublishButtons({
        footerRef,
        setRightMargin
      });
    };
  }, []);

  const moreOptionsDropdownRef = useRef(null);
  const [showMoreOptionsDropdown, setShowMoreOptionsDropdown] = useState(false);

  const [submitButtonWidth, setSubmitButtonWidth] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [makeAStory, setMakeAStory] = useState(false);
  const [storyAllowed, setStoryAllowed] = useState(false);
  const [showStorySwitchConfirm, setShowStorySwitchConfirm] = useState(false);

  const { locations } = useSelector((state: any) => state.locationsList);

  useEffect(() => {
    if (submitButtonRef.current) {
      const { width } = submitButtonRef.current.getBoundingClientRect();
      setSubmitButtonWidth(width);
    }
  }, []);

  useEffect(() => {
    if (isUploadingButtonRef.current && submitButtonWidth !== null) {
      isUploadingButtonRef.current.style.width = `${submitButtonWidth}px`;
    }
  }, [submitButtonWidth]);

  const getSelectedDates = (
    lomavisCreator: any,
    shortForm: boolean = false
  ): string => {
    const formatDateShort = (date: Date | string) =>
      moment.parseZone(date).format('MM.DD');

    if (lomavisCreator.is_recurring_post) {
      if (!lomavisCreator.recurrence_as_str) {
        return '';
      }
      const rruleObj = rrulestr(lomavisCreator.recurrence_as_str);
      // date dtstart and until
      const dtstart = rruleObj.options.dtstart;
      const until = rruleObj.options.until;
      if (!dtstart && !until) {
        return '';
      }

      const rs = `${getDateTimeFormated(dtstart, true)}`;
      if (until) {
        return `${rs} - ${getDateTimeFormated(until, true)}`;
      }
      return rs;

      // get  first
    } else {
      const dates = Object.keys(lomavisCreator.postData)
        .map((key) => {
          if (lomavisCreator.platformEnabled[key]) {
            return lomavisCreator.postData[key].planned_publication_datetime;
          }
          return null;
        })
        .filter(Boolean);

      const dateStrings = Array.from(
        new Set(dates.map((d) => moment.parseZone(d).format()))
      );

      const normalizedDates = dateStrings
        .map((d) => moment.parseZone(d))
        .sort((a, b) => a.valueOf() - b.valueOf());

      if (normalizedDates.length === 0) return '';

      if (normalizedDates.length === 1) {
        return getDateTimeFormattedMoment(normalizedDates[0].format());
      }

      if (shortForm) {
        return `${formatDateShort(
          normalizedDates[0].format()
        )} - ${formatDateShort(
          normalizedDates[normalizedDates.length - 1].format()
        )}`;
      } else {
        return `${getDateTimeFormattedMoment(
          normalizedDates[0].format()
        )} - ${getDateTimeFormattedMoment(
          normalizedDates[normalizedDates.length - 1].format()
        )}`;
      }
    }
  };
  const GetSelectedLocationsCount = (creatorMultipostConfig: any) => {
    // get unique locations
    const locations = Object.keys(creatorMultipostConfig)
      .map((key) => {
        return key.split('_')[0];
      })
      .filter((value, index, self) => self.indexOf(value) === index);
    return locations.length;
  };
  const getSelectedPlatformsCount = (lomavisCreator: any) => {
    const { creator_multipost_config, platformEnabled } = lomavisCreator;

    return Object.keys(creator_multipost_config)
      .map((key) => {
        const platform = key.split(/_(.+)/)[1];
        return platform;
      })
      .filter((value) => platformEnabled[value]).length;
  };
  const getLocationsCountString = (lomavisCreator: any) => {
    const { creator_multipost_config, post_status } = lomavisCreator;
    return `${GetSelectedLocationsCount(creator_multipost_config)} ${
      locations?.length ? '/' + locations.length : ''
    }`;
  };
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const { locationslug } = useParams();
  const { cloudslug } = useParams();
  const lomavisCreator = useSelector((state: any) => state.lomavisCreator);

  const {
    renderedTemplateImageBlob,
    lomavisCreatorConfig,
    is_template_post,
    overlayData,
    platformEnabled,
    general_post_type,
    locationUuid,
    cloudUuid,
    postData
  } = useSelector((state: lomavisCreatorRootState) => state.lomavisCreator);

  function getPlatformsSupportingStory(enabledPlatforms, general_post_type) {
    const storyPlatforms = [];

    Object.entries(enabledPlatforms).forEach(([platform, isEnabled]) => {
      if (!isEnabled) return; // skip disabled platforms

      const featureConfig = platformFeatures[platform]?.[general_post_type];
      if (!featureConfig) return; // skip if platform doesn't support this post type group

      // check if any of the post type options includes POST_TYPE_STORY_KEY
      const hasStoryType = featureConfig.some(
        (postType) => postType.typeKey === POST_TYPE_STORY_KEY
      );

      if (hasStoryType) {
        storyPlatforms.push(platform);
      }
    });

    return storyPlatforms;
  }

  /*
   * Check if a user can execute a given action
   * */
  const checkButtonPermission = (lomavisCreator, key) => {
    if (
      lomavisCreator?.lomavisCreatorConfig?.user_permissions
        ?.can_publish_to_platform
    ) {
      return true;
    }

    if (ACTIONS_THAT_REQUIRE_PERMISSION.includes(key)) {
      return false;
    }

    return true;
  };
  const handleTemplateReplacement = async () => {
    const uuids = await Promise.all(
      renderedTemplateImageBlob?.map(async (item) => {
        const sourceFile = blobToPNGFile(item?.blob, 'renderedImage');
        const dimensions = await getImageDimensionsFromfile(sourceFile);
        const presets = await handleUploadMedia({
          sourceFile,
          dimensions: dimensions,
          location_uuid: lomavisCreatorConfig.location?.uuid,
          uploadType: UPLOAD_TYPE_POST_MEDIA,
          t
        });

        dispatch(
          updateMediaAssetFile({
            uuid: item?.uuid,
            preview_image: presets?.uploaded_object_data?.preview_image_url,
            file: sourceFile,
            assetBlob: item?.blob,
            platform: ALL,
            width: dimensions?.width,
            height: dimensions?.height,
            uploadPresets: presets,
            source_media_uuid: item?.uuid
          })
        );

        return presets?.uuid; // Return UUID for tracking
      })
    );

    dispatch(deleteAllOverlays()); // Proceed current confirmation

    return uuids; // Now returning the UUIDs properly
  };

  function goToLomavisCreatorStory(importFrom: string) {
    const preset = STORY;
    const basePath = locationUuid
      ? PATH_PAGE.locationLomavisCreator.replace(':locationslug', locationslug)
      : cloudUuid
      ? PATH_PAGE.cloudLomavisCreator.replace(':cloudslug', cloudslug)
      : PATH_PAGE.multipostLomavisCreator;

    const queryString = new URLSearchParams({
      import_from: importFrom,
      preset: preset
    }).toString();

    const fullUrl = `${window.location.origin}${basePath}?${queryString}`;

    window.location.href = fullUrl;
  }

  const handleClick = async (key: string) => {
    let keyToVerify = key;

    // check special rules for the button approve
    if (key === BTN_APPROVAL_REQUEST_APPROVE) {
      keyToVerify =
        lomavisCreator?.approval_process.target == TARGET_PUBLISH_WITH_SCHEDULE
          ? BTN_PLAN_PUBLICATION
          : BTN_PUBLISH_NOW;
    }

    if (!checkButtonPermission(lomavisCreator, keyToVerify)) {
      toast.error(t(`lomavisCreator.buttonsBar.permissionError`), {
        duration: 1500,
        position: 'top-right'
      });
      return;
    }

    const checkRes = handleOnClickValidation(lomavisCreator, keyToVerify);
    checkRes.map((error) => {
      error.affectedPlatforms.length === 0
        ? toast.error(t(`lomavisCreator.buttonsBar.${error.message}`), {
            duration: 1500,
            position: 'top-right'
          })
        : error.affectedPlatforms.map((platform) =>
            toast.error(
              t(platform) +
                ' : ' +
                t(`lomavisCreator.buttonsBar.${error.message}`),
              {
                duration: 1500,
                position: 'top-right'
              }
            )
          );
    });
    if (checkRes.length > 0) return;

    // all checks have passed

    setIsSaving(true);

    // If a template has been used and the image has not been replaced, we need to render and replace it.
    if (
      is_template_post &&
      lomavisCreatorConfig?.location &&
      overlayData?.length > 0
    ) {
      const newUuids = await handleTemplateReplacement();
      let allSet = false;

      dispatch(deleteAllOverlays());
      while (!allSet) {
        await sleepFor1000Ms();
        const updatedState = store.getState().lomavisCreator;
        allSet = newUuids.every((uuid) =>
          Object.values(updatedState.postData).some((platform: any) =>
            platform.media.some((obj: any) => obj.uuid === uuid)
          )
        );
      }
    }

    try {
      const lomavisCreator = store.getState().lomavisCreator;

      const res = await sendPostData(lomavisCreator, key, locations);

      // delete the cached post data
      const cacheKey = `${lomavisCreator.locationUuid}_${lomavisCreator.cloudUuid}_${lomavisCreator.is_multipost}_${lomavisCreator.uuid}`;
      // use localforage to delete the cache
      await localforage.removeItem(cacheKey);

      if (makeAStory) {
        goToLomavisCreatorStory(res?.uuid || lomavisCreator.uuid);
      } else {
        window.location.href = res.success_url;
      }
    } catch (e) {
      setIsSaving(false);
      toast.error(t(`lomavisCreator.buttonsBar.submitError`), {
        duration: 2000,
        position: 'top-right'
      });
      console.log(e);
    }
  };

  const scheduleModalToggle = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.modalStates.schedule.toggle
  );
  const {
    ui: { showPostApprovalCreatorModal }
  } = useSelector((state: any) => state.lomavisPostApproval);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [filtredButtons, setFiltredButtons] = useState(BUTTONS_CONFIG);

  useEffect(() => {
    const run = async () => {
      // ✅ Fix generalPostType condition

      const generalPostType =
        general_post_type === POST_TYPE_REEL_KEY ||
        general_post_type === POST_TYPE_STORY_KEY
          ? POST_TYPE_KEY
          : general_post_type;

      // ✅ Get all platforms that can have story type enabled
      const allowedPlatforms = getPlatformsSupportingStory(
        platformEnabled,
        generalPostType
      );

      if (!allowedPlatforms || allowedPlatforms.length === 0) {
        setStoryAllowed(false);
        return;
      }

      // ✅ Validate at least one of those platforms
      let atLeastOneValid = false;

      for (const platform of allowedPlatforms) {
        try {
          const validationState = await validateUpload(
            platform,
            POST_TYPE_STORY_KEY, // assume we’re validating for story type
            postData?.[platform]?.media?.map((item) =>
              item?.file ? item.file : getObjectAsFile(item)
            ) ?? [],
            t,
            false
          );

          if (validationState) {
            atLeastOneValid = true;
            break;
          }
        } catch (error) {
          console.error(`Validation failed for ${platform}:`, error);
        }
      }

      setStoryAllowed(atLeastOneValid);
    };

    run();
  }, [platformEnabled, general_post_type, postData]);

  useEffect(() => {
    const filtered = BUTTONS_CONFIG.filter((button) => {
      return (
        button.showOnPostStatus.includes(lomavisCreator.post_status) &&
        checkButtonPermission(lomavisCreator, button.key) &&
        (!lomavisCreator.has_been_published ||
          lomavisCreator.has_been_published === button?.showInPublishedPost ||
          lomavisCreator?.lomavisCreatorConfig?.importing_post)
      );
    });

    if (
      lomavisCreator.post_status === POST_STATUS_PROPOSED_BY_EXTERNAL_USER
    ) {
      const defaultButtonIndex = filtered.findIndex((button) => button.default);

      if (defaultButtonIndex > 0) {
        const reorderedButtons = [...filtered];
        const [defaultButton] = reorderedButtons.splice(defaultButtonIndex, 1);
        reorderedButtons.unshift(defaultButton);
        setFiltredButtons(reorderedButtons);
        return;
      }
    }

    setFiltredButtons(filtered);
  }, [lomavisCreator.post_status, lomavisCreator.has_been_published]);

  useClickAway(dropdownRef, () => {
    setShowDropdown(false);
  });

  useClickAway(moreOptionsDropdownRef, () => {
    setShowMoreOptionsDropdown(false);
  });

  const renderTooltip = (errors, key, props = {}) => (
    <Tooltip
      className="errors-tooltip rounded"
      id={`tooltip-${key}`}
      {...props}
    >
      <div className="card w-100 rounded">
        <div className="text-start rounded">
          <div className="fw-bold bg-light p-5">
            {t('lomavisCreator.buttonsBar.required_actions')}
          </div>
          <div className="mt-2" />
          <div className="m-2 d-flex flex-column p-2">
            {errors.map((error, index) => (
              <div key={index}>
                <p className="fw-bold">
                  {t(`lomavisCreator.buttonsBar.${error.title}`)}
                </p>
                <p className="text-muted  ms-4 ">
                  {t(`lomavisCreator.buttonsBar.${error.message}`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Tooltip>
  );

  return (
    <div className="d-flex p-2 w-100" ref={footerRef}>
      {!lomavisCreator?.lomavisCreatorConfig?.is_update &&
        lomavisCreator.locationUuid && (
          <UpgradeRequiredTooltipWrapper
            show={!lomavisCreatorConfig.features.bulk_upload}
          >
            <button
              className="btn btn-white me-2 btn-sm d-flex justify-content-center align-items-center"
              onClick={() => {
                dispatch(
                  setBulkImportUiAttribute({
                    attribute: 'showImportModal',
                    value: true
                  })
                );
              }}
            >
              <i className="fa-dutone fa-solid fa-file-import me-1"></i>
              <span>{t('lomavisCreator.buttonsBar.bulkImport')}</span>
            </button>
          </UpgradeRequiredTooltipWrapper>
        )}

      {
        // add a button for post idea
        lomavisCreator?.postIdea && (
          <button
            className="btn btn-secondary me-2 btn-sm d-flex justify-content-center align-items-center"
            onClick={() => {
              dispatch(setShowPostIdeaModal(true));
            }}
          >
            <i className="fa-duotone fa-lightbulb-on me-1"></i>
            <span>{t('lomavisCreator.buttonsBar.openPostIdea')}</span>
          </button>
        )
      }

      <div className="d-flex ms-auto position-relative">
        {lomavisCreator.post_status == POST_STATUS_WAITING_FOR_APPROVAL &&
          !lomavisCreator?.approval_process
            ?.feedback_from_current_user_required &&
          lomavisCreator.post_sub_status !=
            POST_SUB_STATUS_SAVED_AS_APPROVED_POST && (
            <div className={'d-flex flex-row'}>
              <OverlayTrigger
                key={'overlayTriggerRejectDisabled'}
                overlay={
                  <Tooltip>
                    <span className="text-gray-400 fw-bold d-block text-start">
                      {t('lomavisCreator.buttonsBar.approveDisabled')}
                    </span>
                  </Tooltip>
                }
              >
                <div>
                  <button className="btn btn-danger me-2 btn-sm d-flex justify-content-center align-items-center disabled">
                    <i className="fa-solid fa-thumbs-down me-1"></i>
                    <span>{t('lomavisCreator.buttonsBar.reject')}</span>
                  </button>
                </div>
              </OverlayTrigger>

              <OverlayTrigger
                key={'overlayTriggerRejectDisabled'}
                overlay={
                  <Tooltip>
                    <span className="text-gray-400 fw-bold d-block fs-7 text-start">
                      {t('lomavisCreator.buttonsBar.approveDisabled')}
                    </span>
                  </Tooltip>
                }
              >
                <div>
                  <button className="btn btn-success me-2 btn-sm d-flex justify-content-center align-items-center disabled">
                    <i className="fa-solid fa-thumbs-up me-1"></i>
                    <span>{t('lomavisCreator.buttonsBar.approve')}</span>
                  </button>
                </div>
              </OverlayTrigger>
            </div>
          )}

        {lomavisCreator?.approval_process
          ?.feedback_from_current_user_required &&
          lomavisCreator.post_status == POST_STATUS_WAITING_FOR_APPROVAL && (
            <div className="d-flex align-items-center me-2">
              <OverlayTrigger
                key={BTN_SAVE_AS_DRAFT}
                overlay={(props) => {
                  const validation = checkButtonValidation(
                    lomavisCreator,
                    BTN_SAVE_AS_DRAFT
                  );
                  const CMP = validation.hasError ? (
                    renderTooltip(
                      validation.errorsList,
                      BTN_SAVE_AS_DRAFT,
                      props
                    )
                  ) : (
                    <></>
                  );
                  // return CMP with props
                  return CMP;
                }}
              >
                <button
                  className="btn btn-danger me-2 btn-sm d-flex justify-content-center align-items-center"
                  onClick={async () => {
                    await handleClick(BTN_APPROVAL_REQUEST_REJECT);
                  }}
                >
                  <i className="fa-solid fa-thumbs-down me-1"></i>
                  <span>{t('lomavisCreator.buttonsBar.reject')}</span>
                  {checkButtonValidation(lomavisCreator, BTN_SAVE_AS_DRAFT)
                    .hasError && (
                    <i className="fa-regular fa-triangle-exclamation text-white ms-2"></i>
                  )}
                </button>
              </OverlayTrigger>

              <OverlayTrigger
                key={BTN_APPROVAL_REQUEST_APPROVE}
                overlay={(props) => {
                  let approvalRuleSet = BTN_PUBLISH_NOW;

                  if (
                    lomavisCreator?.approval_process.target ==
                    TARGET_PUBLISH_WITH_SCHEDULE
                  ) {
                    approvalRuleSet = BTN_PLAN_PUBLICATION;
                  }

                  const validation = checkButtonValidation(
                    lomavisCreator,
                    approvalRuleSet
                  );
                  const CMP = validation.hasError ? (
                    renderTooltip(validation.errorsList, approvalRuleSet, props)
                  ) : (
                    <></>
                  );
                  // return CMP with props
                  return CMP;
                }}
              >
                <button
                  className="btn btn-success me-2 btn-sm d-flex justify-content-center align-items-center"
                  onClick={async () => {
                    await handleClick(BTN_APPROVAL_REQUEST_APPROVE);
                  }}
                >
                  <i className="fa-solid fa-thumbs-up me-1"></i>
                  <span>{t('lomavisCreator.buttonsBar.approve')}</span>
                  {checkButtonValidation(
                    lomavisCreator,
                    lomavisCreator?.approval_process.target ==
                      TARGET_PUBLISH_WITH_SCHEDULE
                      ? BTN_APPROVAL_REQUEST_APPROVE
                      : BTN_PUBLISH_NOW
                  ).hasError && (
                    <i className="fa-regular fa-triangle-exclamation text-white ms-2"></i>
                  )}
                </button>
              </OverlayTrigger>
            </div>
          )}

        {lomavisCreator?.lomavisCreatorConfig?.is_update && (
          <Dropdown
            className="d-none d-lg-inline"
            show={showMoreOptionsDropdown}
            ref={moreOptionsDropdownRef}
          >
            <Dropdown.Toggle
              variant="secondary"
              size="sm"
              onClick={() => {
                setShowMoreOptionsDropdown(!showMoreOptionsDropdown);
              }}
              className="btn-sm btn btn-primary dropdown-toggle px-3 me-2"
            >
              {t('lomavisCreator.buttonsBar.moreOptions')}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {lomavisCreator?.lomavisCreatorConfig?.approval_url && (
                <Dropdown.Item
                  href={lomavisCreator?.lomavisCreatorConfig?.approval_url}
                >
                  {t(
                    'lomavisCreator.buttonsBare.moreActions.sendApprovalEmail'
                  )}
                </Dropdown.Item>
              )}

              {lomavisCreator?.lomavisCreatorConfig?.import_post_url && (
                <Dropdown.Item
                  href={lomavisCreator?.lomavisCreatorConfig?.import_post_url}
                >
                  {t('lomavisCreator.buttonsBare.moreActions.importPost')}
                </Dropdown.Item>
              )}

              <Dropdown.Item
                href={lomavisCreator?.lomavisCreatorConfig?.delete_url}
                className={'text-danger'}
              >
                {t('lomavisCreator.buttonsBare.moreActions.delete')}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
        {lomavisCreator?.lomavisCreatorConfig?.is_multipost && (
          <button
            className="btn btn-secondary me-2 btn-sm d-flex justify-content-center align-items-center"
            onClick={() => dispatch(setShowProfileGroupSelectModal(true))}
          >
            <span>{t('lomavisCreator.buttonsBar.profile_groups')} </span>
            <OverlayTrigger
              placement="top"
              overlay={
                // make width depend on the content
                <Tooltip>
                  <div className="text-gray-400 fw-bold fs-8 text-start">
                    <ul
                      className="m-0 w-100 ps-0"
                      style={{ listStyle: 'none' }}
                    >
                      <li className="m-0">
                        {t(
                          'lomavisCreator.buttonsBar.selected_locations_number'
                        )}
                        :{' '}
                        {GetSelectedLocationsCount(
                          lomavisCreator.creator_multipost_config
                        )}
                      </li>
                      <li>
                        {t(
                          'lomavisCreator.buttonsBar.selected_platforms_count'
                        )}
                        : {getSelectedPlatformsCount(lomavisCreator)}
                      </li>
                    </ul>
                  </div>
                </Tooltip>
              }
            >
              <span className="badge bg-light m-0 ms-2 text-dark">
                {getLocationsCountString(lomavisCreator)}
              </span>
            </OverlayTrigger>
          </button>
        )}
        {
          // button for post approval modal
          <PostApprovalSection />
        }
        {!lomavisCreator?.lomavisCreatorConfig?.cloud && (
          <button
            className="btn btn-secondary me-2 btn-sm d-flex justify-content-center align-items-center"
            onClick={() =>
              dispatch(
                setModalUiContent({
                  modal: 'schedule',
                  attribute: 'toggle',
                  value: !scheduleModalToggle
                })
              )
            }
          >
            <span>
              {lomavisCreator.is_recurring_post ? (
                <i className="fa-duotone fa-repeat me-1"></i>
              ) : (
                <i className="fa-duotone fa-calendar-alt me-1"></i>
              )}
            </span>

            <span className="d-none d-lg-inline">
              {getSelectedDates(lomavisCreator)
                ? getSelectedDates(lomavisCreator)
                : t('lomavisCreator.buttonsBar.schedule')}
            </span>
            <span className="d-inline d-lg-none">
              {getSelectedDates(lomavisCreator, true)
                ? getSelectedDates(lomavisCreator, true)
                : t('lomavisCreator.buttonsBar.schedule')}
            </span>
          </button>
        )}

        <div className="position-relative">
          {lomavisCreator.lomavisCreatorConfig.is_multipost &&
            lomavisCreator.multipost_copied_to_profile_group_for_approval && (
              <div
                className="card position-absolute px-2 small fw-bold text-primary"
                style={{
                  top: '-20px',
                  right: '20px',
                  zIndex: 100,
                  whiteSpace: 'nowrap'
                }}
              >
                {t('lomavisCreator.buttonsBar.post_active_for_approval')}
              </div>
            )}

          <div style={{ marginRight: rightMargin }}>
            {true && (
              <Dropdown
                as={ButtonGroup}
                show={showDropdown}
                ref={dropdownRef}
                drop="up"
                align={'end'}

                // onToggle={() => setShowDropdown(!showDropdown)}
              >
                {isSaving ? (
                  <Button
                    ref={isUploadingButtonRef}
                    variant="primary"
                    size="sm"
                  >
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{' '}
                    {t('lomavisCreator.buttonsBar.saving')}
                  </Button>
                ) : (
                  <>
                    <Button
                      ref={submitButtonRef}
                      variant="primary"
                      size="sm"
                      onClick={async () => {
                        await handleClick(filtredButtons[0].key);
                      }}
                    >
                      {t(
                        `lomavisCreator.buttonsBar.${
                          lomavisCreator.cloudUuid
                            ? filtredButtons[0].buttonTextCloud
                            : filtredButtons[0].buttonTextNormal
                        }`
                      )}
                    </Button>

                    <Dropdown.Toggle
                      onClick={() => {
                        setShowDropdown(!showDropdown);
                      }}
                      className="btn-sm btn btn-primary dropdown-toggle dropdown-toggle-split bg-primary border border-1 border-end-0 border-top-0 border-bottom-0 border-white"
                      // onClick={handleButtonClick}
                    />

                    <Dropdown.Menu>
                      <div
                        className={`p-2 d-flex w-100 border-bottom border-2 mb-2 ${
                          lomavisCreator?.lomavisCreatorConfig?.is_update
                            ? 'justify-content-center'
                            : 'justify-content-start'
                        }`}
                      >
                        {lomavisCreator?.lomavisCreatorConfig?.is_update ? (
                          <LomavisOverlayToolTip1
                            showTooltip={!storyAllowed}
                            text={t(
                              'lomavisCreator.buttonsBar.storyModeNotAllowed'
                            )}
                            placement="top"
                          >
                            <button
                              type="button"
                              className="btn btn-sm btn-white d-flex align-items-center gap-2 mx-auto"
                              disabled={!storyAllowed}
                              onClick={() => {
                                if (!storyAllowed) return;
                                setShowDropdown(false);
                                setShowStorySwitchConfirm(true);
                              }}
                            >
                              <span className="fs-7">
                                {t(
                                  'lomavisCreator.buttonsBar.create_story_for_post'
                                )}
                              </span>
                              <LomavisMoreInfoIcon
                                text={t(
                                  'lomavisCreator.buttonsBar.create_story_for_post.tooltip'
                                )}
                                size={6}
                                show={500}
                                hide={500}
                              />
                            </button>
                          </LomavisOverlayToolTip1>
                        ) : (
                          <div
                            className={`d-flex align-items-center ${
                              storyAllowed
                                ? 'cursor-pointer'
                                : 'cursor-not-allowed'
                            }`}
                            role="button"
                            tabIndex={0}
                            aria-disabled={!storyAllowed}
                            aria-pressed={makeAStory}
                            onClick={() => {
                              if (!storyAllowed) return;
                              setMakeAStory((prev) => !prev);
                            }}
                          >
                            <LomavisOverlayToolTip1
                              showTooltip={!storyAllowed}
                              text={t(
                                'lomavisCreator.buttonsBar.storyModeNotAllowed'
                              )}
                              placement="top"
                            >
                              {/* prevent bubbling so the outer onClick doesn't fire as well */}
                              <span
                                className="d-inline-flex"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <Form.Check
                                  type="switch"
                                  id="create-story-switch"
                                  className="cursor-pointer"
                                  style={{
                                    transform: 'scale(0.7)',
                                    transformOrigin: 'center center'
                                  }}
                                  disabled={!storyAllowed}
                                  checked={makeAStory}
                                  onChange={(e) =>
                                    setMakeAStory(e.target.checked)
                                  }
                                />
                              </span>
                            </LomavisOverlayToolTip1>

                            <div
                              className={`fs-7 d-flex gap-2 align-items-center ${
                                !storyAllowed && 'text-muted'
                              }`}
                            >
                              <span>
                                {' '}
                                {t(
                                  'lomavisCreator.buttonsBar.create_story_for_post'
                                )}
                              </span>

                              <LomavisMoreInfoIcon
                                text={t(
                                  'lomavisCreator.buttonsBar.create_story_for_post.tooltip'
                                )}
                                size={6}
                                show={500}
                                hide={500}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      {filtredButtons.slice(1).map((button) => {
                        const validation = checkButtonValidation(
                          lomavisCreator,
                          button.key
                        );
                        const show = showButton(lomavisCreator, button);

                        if (!show) {
                          return <></>;
                        }
                        return (
                          <div
                            key={button.key}
                            onClick={async () => {
                              await handleClick(button.key);
                            }}
                            className="bg-hover-light"
                          >
                            <OverlayTrigger
                              key={button.key}
                              placement="left"
                              overlay={
                                validation.hasError ? (
                                  renderTooltip(
                                    validation.errorsList,
                                    button.key
                                  )
                                ) : (
                                  <></>
                                )
                              }
                            >
                              <Dropdown.Item as="button">
                                <div className="d-flex align-items-center justify-content-between fs-5">
                                  <span>
                                    {t(
                                      `lomavisCreator.buttonsBar.${
                                        lomavisCreator.cloudUuid
                                          ? button.buttonTextCloud
                                          : button.buttonTextNormal
                                      }`
                                    )}
                                  </span>
                                  <span>
                                    {validation.hasError && (
                                      <i className="fa-regular fa-triangle-exclamation text-warning me-2 ms-2"></i>
                                    )}
                                  </span>
                                </div>
                              </Dropdown.Item>
                            </OverlayTrigger>
                            <div className="mt-1"></div>
                          </div>
                        );
                      })}
                    </Dropdown.Menu>
                  </>
                )}
              </Dropdown>
            )}
          </div>
        </div>
      </div>

      <ConfirmationModal
        title={t('lomavisCreator.buttonsBar.create_story_for_post.confirmTitle')}
        body={t('lomavisCreator.buttonsBar.create_story_for_post.confirmBody')}
        primaryText={t('lomavisCreator.buttonsBar.create_story_for_post.confirmPrimary')}
        secondaryText={t('lomavisCreator.buttonsBar.create_story_for_post.confirmSecondary')}
        show={showStorySwitchConfirm}
        handleClose={() => setShowStorySwitchConfirm(false)}
        handleSecondary={() => setShowStorySwitchConfirm(false)}
        handlePrimary={() => {
          setShowStorySwitchConfirm(false);
          goToLomavisCreatorStory(lomavisCreator.uuid);
        }}
      />
    </div>
  );
};
